import { css } from 'styled-components'

import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

/**
 * Shared CSS bridges for surfaces that keep legacy brand-green under rebrand.
 * Pair with `useRebrandSuccessDarkColour()` for LuxKit `colour` props so JSX and
 * CSS cannot drift onto different tokens.
 *
 * Theme/Sheet has no success-dark border token, so borders still start as
 * highlight-primary-dark (or a custom class) and remap here.
 */

/** Remap this element's border to messaging success-dark under rebrand. */
export const rebrandSuccessDarkBorderOverride = css`
  body.${REBRAND_PALETTE_CLASS} && {
    border-color: var(--palette-messaging-success-dark-foreground);
  }
`

/**
 * Remap border when Pane/Sheet is rendered with `border="highlight-primary-dark"`
 * (produces `.border-highlight-primary-dark`). Keep in sync with that prop at the call site
 * so the recommended card stays green while non-recommended cards stay light-foreground.
 */
export const rebrandSuccessDarkHighlightBorderOverride = css`
  body.${REBRAND_PALETTE_CLASS} &&.border-highlight-primary-dark {
    border-color: var(--palette-messaging-success-dark-foreground);
  }
`

/** Remap border when the element uses a custom class under rebrand (e.g. `.protect-border`). */
export const rebrandSuccessDarkClassBorderOverride = (className: string) => css`
  body.${REBRAND_PALETTE_CLASS} &&.${className} {
    border-color: var(--palette-messaging-success-dark-foreground);
  }
`

/**
 * Remap PromotionLabel `premium` (`kind-primary` + `variant-highlight-primary-dark`)
 * fill/border/contrast to messaging success-dark under rebrand.
 */
export const rebrandSuccessDarkPromotionLabelOverride = css`
  body.${REBRAND_PALETTE_CLASS} &.kind-primary.variant-highlight-primary-dark {
    background-color: var(--palette-messaging-success-dark-background);
    border-color: var(--palette-messaging-success-dark-foreground);
    color: var(--palette-messaging-success-dark-contrast);
  }
`
